module.exports = __webpack_public_path__ + "static/img/02bg2en.6408591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/report/02week/02bg2en.png
// module id = qUw6
// module chunks = 0